import type { Transaction } from '@api/hooks/types/getTransactions';
import { TFunction } from 'i18next';
import type { FXPayment } from 'types/operations';

import type { CardConfig } from '../types';

export const getSenderRecipientCard = (
	operation: Transaction | FXPayment,
	t: TFunction,
): CardConfig => ({
	title: t('senderRecipient.title'),
	groups: [
		{
			fields: [
				{
					title: t('senderRecipient.payerName'),
					content: operation?.payer?.name,
				},
				{
					title: t('senderRecipient.payerAccount'),
					content: operation?.payer?.iban,
					canCopy: true,
				},
				{
					title: t('senderRecipient.beneficiaryName'),
					content: operation?.beneficiary?.name,
				},
				{
					title: t('senderRecipient.beneficiaryAccount'),
					content: operation?.beneficiary?.account_number,
					canCopy: true,
				},
			],
		},
	],
});
